import React, { useContext } from 'react';

const contextName = 'landingData';
const landingContext = React.createContext({});
landingContext.displayName = contextName;

export const LandingProvider = landingContext.Provider;
export const useAppContext = () => (useContext(landingContext) || {});
export default landingContext;
